import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';

import { setPanelDPL } from '@reducers/options/panel/actions';
import Application from '../../../Application';
import { SafetyBarrierObject } from '@object-generators/safety-barrier';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

const Dpl = props => {
  if (
    props.type === Application.types.SAFETY_BARRIER && 
    props.options.object.type === SafetyBarrierObject.types.STAIRS && 
    props.isDpl
  ) {
    return (
      <Input
        prefix="Dpl ="
        postfix={unitLabel(props.unit)}
        className="base-plate__input_block"
        id="dpl"
        type="number"
        minValue={0}
        value={props.dplValue}
        onUpdate={value => {
          props.setDplValue(value, props.unit);
        }}
      />
    );
  }

  return null;
};

const mapState = state => {
  const unit = state.main.units.distance;

  if (state.options.panel.dpl) {
    return {
      type: state.main.appType,
      options: state.options,
      isDpl: state.options.panel.dpl.active,
      dplValue: unitTransform(state.options.panel.dpl.value).from(defaultUnits.DISTANCE).to(unit),
      unit
    };
  }
  else 
    return {}; // mapStateToProps() in Connect(Dpl) must return a plain object. Instead received undefined.
};

const mapDispatch = dispatch => ({
  setDplValue: (value, unit) => dispatch(setPanelDPL({
      value: unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE)
  })),
});

export default connect(mapState, mapDispatch)(Dpl);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Dpl.js